import { useEffect, useState } from "react";
import API_URL from "../config";

const PRESET_COLORS = [
  { label: "Vert",   value: "#1a7a3c" },
  { label: "Rouge",  value: "#cc1f1f" },
  { label: "Bleu",   value: "#1a2756" },
  { label: "Or",     value: "#f5c200" },
  { label: "Orange", value: "#C6582C" },
  { label: "Violet", value: "#6E4F9E" },
];

export default function InfoList({ readOnly = false }) {
  const [infos, setInfos]     = useState([]);
  const [openId, setOpenId]   = useState(null);
  const [editId, setEditId]   = useState(null);
  const [editForm, setEditForm] = useState({ titre: "", contenu: "", details: "", badge: "", badgeColor: "#1a7a3c" });
  const [erreur, setErreur]   = useState("");

  useEffect(() => { fetchInfos(); }, []);

  const fetchInfos = async () => {
    try {
      const res = await fetch(`${API_URL}/api/info`);
      if (!res.ok) throw new Error("Réponse serveur KO");
      setInfos(await res.json());
      setErreur("");
    } catch {
      setErreur("Impossible de charger les infos.");
    }
  };

  const toggleDetails = (id) => setOpenId(openId === id ? null : id);

  const handleDelete = async (id) => {
    try {
      await fetch(`${API_URL}/api/info/${id}`, { method: "DELETE" });
      setInfos(infos.filter((info) => info._id !== id));
    } catch (err) { console.error(err); }
  };

  const handleEditStart = (info) => {
    setEditId(info._id);
    setEditForm({
      titre: info.titre, contenu: info.contenu, details: info.details || "",
      badge: info.badge || "", badgeColor: info.badgeColor || "#1a7a3c",
    });
  };

  const handleEditSave = async (id) => {
    try {
      const res = await fetch(`${API_URL}/api/info/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editForm),
      });
      if (!res.ok) throw new Error("Erreur serveur");
      setEditId(null);
      fetchInfos();
    } catch (err) { console.error(err); }
  };

  if (erreur) return <div className="p-4 bg-red-100 text-red-700 rounded">⚠️ {erreur}</div>;
  if (infos.length === 0) return <div className="p-4 text-gray-500 text-center">Aucune information pour le moment.</div>;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 20, padding: "8px 0" }}>
      {infos.map((info) => (
        <div key={info._id} style={{
          position: "relative",
          width: "calc(50% - 10px)",
          minWidth: 280,
          background: "#F5EAD3",
          border: "3px solid #0d1117",
          borderRadius: 14,
          boxShadow: "5px 5px 0 #0d1117",
          padding: "22px 22px 18px",
          boxSizing: "border-box",
        }}>

          {/* Badge en haut à droite */}
          {info.badge && (
            <span style={{
              position: "absolute", top: -14, right: 16,
              background: info.badgeColor || "#1a7a3c",
              color: "#fff",
              fontWeight: 800, fontSize: "0.72rem",
              textTransform: "uppercase", letterSpacing: "0.08em",
              padding: "5px 14px", borderRadius: 20,
              border: "2.5px solid #0d1117",
              boxShadow: "2px 2px 0 #0d1117",
            }}>
              {info.badge}
            </span>
          )}

          {editId === info._id ? (
            /* ── Mode édition ── */
            <div className="space-y-2">
              <input value={editForm.titre}
                onChange={(e) => setEditForm({ ...editForm, titre: e.target.value })}
                className="w-full border border-gray-300 rounded px-2 py-1 text-sm font-bold"
                placeholder="Titre" />
              <textarea value={editForm.contenu}
                onChange={(e) => setEditForm({ ...editForm, contenu: e.target.value })}
                className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                placeholder="Contenu" rows={3} />
              <textarea value={editForm.details}
                onChange={(e) => setEditForm({ ...editForm, details: e.target.value })}
                className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                placeholder="Détails (optionnel)" rows={2} />
              {/* Badge edit */}
              <div className="p-2 bg-white rounded border space-y-2">
                <p className="text-xs font-bold text-gray-600">🏷️ Badge</p>
                <input type="text" value={editForm.badge}
                  onChange={(e) => setEditForm({ ...editForm, badge: e.target.value })}
                  className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
                  placeholder="Texte du badge" maxLength={20} />
                {editForm.badge && (
                  <div className="flex flex-wrap gap-1">
                    {PRESET_COLORS.map((c) => (
                      <button type="button" key={c.value}
                        onClick={() => setEditForm({ ...editForm, badgeColor: c.value })}
                        style={{
                          background: c.value, color: "#fff",
                          border: editForm.badgeColor === c.value ? "2px solid #111" : "1px solid transparent",
                          borderRadius: 12, padding: "2px 8px",
                          fontWeight: 700, fontSize: "0.65rem", cursor: "pointer",
                        }}>
                        {c.label}
                      </button>
                    ))}
                    <input type="color" value={editForm.badgeColor}
                      onChange={(e) => setEditForm({ ...editForm, badgeColor: e.target.value })}
                      style={{ width: 26, height: 26, borderRadius: 6, border: "1px solid #ccc", cursor: "pointer" }} />
                  </div>
                )}
              </div>
              <div className="flex gap-2">
                <button onClick={() => handleEditSave(info._id)}
                  className="flex-1 px-2 py-1 bg-green-500 text-white rounded text-sm hover:bg-green-600">
                  💾 Sauvegarder
                </button>
                <button onClick={() => setEditId(null)}
                  className="flex-1 px-2 py-1 bg-gray-200 text-gray-700 rounded text-sm hover:bg-gray-300">
                  Annuler
                </button>
              </div>
            </div>
          ) : (
            /* ── Mode lecture ── */
            <>
              <h3 style={{ fontWeight: 800, fontSize: "1.05rem", color: "#0d1117", marginBottom: 8 }}>
                {info.titre}
              </h3>
              <p style={{ color: "#374151", fontSize: "0.92rem", lineHeight: 1.55, marginBottom: 10 }}>
                {info.contenu}
              </p>
              <p style={{ fontSize: "0.78rem", color: "#6b7280", marginBottom: 8 }}>
                🕒 {info.createdAt ? new Date(info.createdAt).toLocaleString("fr-FR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" }) : ""}
              </p>

              {info.details && (
                <>
                  <button onClick={() => toggleDetails(info._id)}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: 6,
                      fontWeight: 700, fontSize: "0.78rem", textTransform: "uppercase",
                      letterSpacing: "0.06em", color: "#1a2756",
                      background: "none", border: "none", cursor: "pointer", padding: 0,
                      marginBottom: 6,
                    }}>
                    {openId === info._id ? "Masquer les détails" : "VOIR LES DÉTAILS →"}
                  </button>
                  {openId === info._id && (
                    <div style={{ background: "#fff", border: "2px solid #0d1117", borderRadius: 8, padding: 12, marginTop: 6, fontSize: "0.88rem", color: "#374151" }}>
                      {info.details}
                    </div>
                  )}
                </>
              )}

              {!readOnly && (
                <div className="flex gap-2 mt-3">
                  <button onClick={() => handleEditStart(info)}
                    className="flex-1 px-2 py-1 bg-blue-50 text-blue-600 rounded text-sm hover:bg-blue-100">
                    ✏️ Modifier
                  </button>
                  <button onClick={() => handleDelete(info._id)}
                    className="flex-1 px-2 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600">
                    🗑️ Supprimer
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
}
